import isObject from 'lodash-es/isObject';
import { RenderResult } from '@dojo/framework/core/interfaces';
import { VariantTitle } from './interfaces';

export function isVariantTitle(title: RenderResult | VariantTitle): title is VariantTitle {
	return Boolean(title && isObject(title) && 'open' in title);
}
